export default __webpack_public_path__ + "static/media/element_67.c52fd8c4.jpg";